import type { ExtractPropTypes, PropType } from 'vue';

// ============================================================
//  状态图图片配置（组件内置，如需更换图片源直接改这里，不依赖全局静态资源配置）
// ============================================================

/** 图片服务器基础地址 */
const IMG_BASE = 'https://img.goooy.cn/image/admin';

/** 空状态 / 异常状态图片（全链接，无需项目配置静态资源地址） */
export const STATUS_EMPTY_IMAGES: Record<string, string> = {
  data: `${IMG_BASE}/20260718/7b03da06e0e961f4940fa3a80729678e.png`,
  search: `${IMG_BASE}/20260718/dc12907c2858d18c03261d2fc6c5b6dc.png`,
  shopCart: `${IMG_BASE}/20260718/98e398718ee70a5fde971365ca846b67.png`,
  address: `${IMG_BASE}/20260718/890cc27ca24287995b4d9de9b4826d9b.png`,
  order: `${IMG_BASE}/20260718/88432d3c529d7dce48307ee561c2edd9.png`,
  coupon: `${IMG_BASE}/20260718/58d0652311a4aef1e398bad5736bd015.png`,
  favor: `${IMG_BASE}/20260718/dc70ef9c805ca7e0f36876a3b60435c4.png`,
  history: `${IMG_BASE}/20260718/6c398747c8b30063549516f165fdd5d3.png`,
  news: `${IMG_BASE}/20260718/ec50d5535047ea2af3ae2bd7686ce49a.png`,
  message: `${IMG_BASE}/20260718/0eb24aa04e46352dfbb5cbc368e1752b.png`,
  list: `${IMG_BASE}/20260718/0f359f62122e5918f22b75b8c27d6c0f.png`,
  comment: `${IMG_BASE}/20260718/0e27be7970dc9771c6e53dcc8409b70a.png`,
  nologin: `${IMG_BASE}/20260718/700e7ab5978f4d1b15f92e7471c77dd2.png`,
  permission: `${IMG_BASE}/20260718/f371fabd323261ccf0aff9c153d0c296.png`,
  developing: `${IMG_BASE}/20260718/ce6c02775dfe0fb024d9447ddbcd6289.png`,
};

/** 状态编码 */
export type StatusCode
  = | 'success' // 正常状态
    | 'no-data' // 无数据
    | 'not-loaded' // 未加载（初始状态，隐藏一切）
    | 'no-login' // 无登录
    | 'forbidden' // 无权限
    | 'no-network' // 无网络
    | 'data-err' // 数据异常
    | 'system-err' // 系统/服务器异常
    | 'network-err' // 网络异常
    | 'developing'; // 开发中

/** 无状态模型 */
export type EmptyMode
  = | 'data' // 数据为空
    | 'search' // 搜索
    | 'shopCart' // 购物车
    | 'address' // 地址
    | 'order' // 订单
    | 'coupon' // 优惠券
    | 'favor' // 收藏
    | 'history' // 历史
    | 'news' // 新闻/通知
    | 'message' // 消息
    | 'comment' // 评论
    | 'list'; // 列表

/** @deprecated 使用 EmptyMode 代替 */
export type NodataCode = EmptyMode;

export const statusTipsProps = {
  code: {
    type: String as PropType<'success' | 'no-data' | 'not-loaded' | 'no-login' | 'forbidden' | 'no-network' | 'data-err' | 'system-err' | 'network-err' | 'developing'>,
    default: 'success',
  },
  emptyMode: {
    type: String as PropType<EmptyMode>,
    default: 'data',
  },
  text: String as PropType<string>,
  image: String as PropType<string>,
  showRetry: {
    type: Boolean,
    default: true,
  },
  retryTitle: String as PropType<string>,
  errorCode: [String, Number] as PropType<string | number>,
  errorMsg: String as PropType<string>,
};

export type StatusTipsProps = ExtractPropTypes<typeof statusTipsProps>;
